module.exports = __webpack_public_path__ + "static/media/chevron-down.56c5e32c.svg";